import { decodeJwtPayload } from './jwt';

const TOKEN_KEY = 'um_ui_token';
const REFRESH_TOKEN_KEY = 'um_ui_refresh_token';
const SELECTED_APP_KEY = 'um_ui_selected_app_id';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const setToken = (token) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
};

export const setRefreshToken = (token) => {
    if (token) localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const clearToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
};

// Persists the app selected in the top-of-page app dropdown so it stays
// selected across page navigation instead of resetting to the first app.
export const getSelectedAppId = () => localStorage.getItem(SELECTED_APP_KEY) || '';

export const setSelectedAppId = (appId) => {
    if (appId) {
        localStorage.setItem(SELECTED_APP_KEY, appId);
    } else {
        localStorage.removeItem(SELECTED_APP_KEY);
    }
};

// Picks the app to default the dropdown to: explicit query param wins, then the
// last app the user selected (if still in their app list), then the first app.
export const resolveDefaultAppId = (apps, queryAppId) => {
    if (queryAppId && apps.some((a) => a.app_id === queryAppId)) return queryAppId;
    const stored = getSelectedAppId();
    if (stored && apps.some((a) => a.app_id === stored)) return stored;
    return apps[0]?.app_id || '';
};

// Decode the is_portal_admin claim from the stored authZ JWT. Drives which apps the
// console loads and which portal-admin-only routes/nav are shown. Client-side gating
// is UX/defense-in-depth only — the backend remains the real enforcement.
const isTruthyClaim = (v) => v === true || v === 1 || v === '1';

export const getIsPortalAdmin = () => isTruthyClaim(decodeJwtPayload(getToken())?.is_portal_admin);

// Forget the app picked in the app switcher (sign-out), so the next person to sign in
// on this browser does not inherit it.
export const clearSelectedAppId = () => localStorage.removeItem(SELECTED_APP_KEY);

// Who is signed in, from the stored authZ JWT (display only — never for authorisation).
// actingAs: the token came from "enact user" — requesting_user_id is the ORIGINAL
// admin's id, and username/name are the enacted user's.
export const getCurrentUser = () => {
    const payload = decodeJwtPayload(getToken());
    if (!payload) return null;
    const { username, first_name: first, last_name: last, email_id: email } = payload;
    const name = [first, last].filter(Boolean).join(' ') || username || email || '';
    if (!name) return null;
    return {
        name,
        username: username || email || '',
        email: email || '',
        phone: payload.phone_no || '',
        isPortalAdmin: isTruthyClaim(payload.is_portal_admin),
        appId: payload.app_id || '',
        tenantName: payload.tenant_name || '',
        actingAs: Boolean(payload.requesting_user_id),
    };
};
